import { useInfiniteQuery } from '@zg-rentals/react-query5';
import { RentalManagerAccountViewZrmListingsWebApiHandler_units } from '@zg-rentals/ts-rental-manager-api-client';

import PropertiesConstants from '../../../constants/PropertiesConstants';

import type { ListingPropertyUnitsResponseDto, ListingUnitDto } from '@zg-rentals/ts-rental-manager-api-client';

// Page size for a property's units, matching the expanded-card units query on FlexiblePropertiesPage.
export const LISTING_UNITS_PAGE_LIMIT = PropertiesConstants.PROPERTIES_MULTIPLEX_LIMIT_DEFAULT;

export const useGetListingPropertyUnits = (groupId: string) => {
  const { data, fetchNextPage, hasNextPage, isFetching, isFetchingNextPage, isError, error } = useInfiniteQuery<
    ListingPropertyUnitsResponseDto,
    Error,
    { pages: Array<ListingPropertyUnitsResponseDto> },
    Array<string | undefined>,
    string
  >({
    queryKey: ['getListingPropertyUnits', groupId],
    queryFn: async ({ pageParam }) =>
      RentalManagerAccountViewZrmListingsWebApiHandler_units({
        groupId,
        limit: LISTING_UNITS_PAGE_LIMIT,
        ...(pageParam ? { startKeyExclusive: pageParam } : {}),
      }),
    initialPageParam: '',
    getNextPageParam: (lastPage) => (lastPage.pager?.hasMore ? lastPage.pager.endKey : undefined),
    enabled: Boolean(groupId),
    meta: {
      tags: ['getListingPropertyUnits', groupId],
      context: {
        api: 'RentalManagerAccountViewZrmListingsWebApiHandler_units',
        details: 'useGetListingPropertyUnits',
      },
    },
  });

  const units: Array<ListingUnitDto> = data?.pages.flatMap((page) => page.units) ?? [];

  return { units, fetchNextPage, hasNextPage, isFetching, isFetchingNextPage, isError, error };
};
